import React, { Component } from "react";
import {
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from "mdbreact";
import axios from "axios";
import { Select } from "antd";
import ConfigData from "../Components/config";
import Swal from "sweetalert2";
import RatingModal from "../Components/RatingModal";
import "./addpetition.css";

export default class Addpetition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      checkconfirm: true,
      modalshowconfirm: false,
      CheckImage: false,
      SelecteTypesRubrong: null,
      TypesRubrongName: null,
      TypesRubrongMoney: null,
      OLDID: null,
      nameeng: null,
      FULLNAME: null,
      Type_name: null,
      level_name_long: null,
      t_mjname: null,
      numhome: null,
      moo: null,
      Road: null,
      SOI: null,
      Province: null,
      District: null,
      Subdistrict: null,
      PostalCode: null,
      number: null,
      RubrongTH: false,
      RubrongEN: false,
      myFile: null,
      noticeFile: null,
      box1: 0,
      box2: 0,
      totalRubrong: 0,
      totalMoney: 0,
      box3: null,
      petition: 0,
      petitionValue: undefined,
      certificatecoure: null,

      array_DetailPetition: [],
      array_TypePetition: [],
      array_Certificatecoure: [],
      feedback: 0,
      feedback1: 0,
      feedback2: 0,
    };
    this.handleTypePetitionChange = this.handleTypePetitionChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNewsChange = this.handleNewsChange.bind(this);
    this.handlePetitionChange = this.handlePetitionChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handlemyFileChange = this.handlemyFileChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.modalSubmit_open = this.modalSubmit_open.bind(this);
    this.modalSubmit_close = this.modalSubmit_close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.Alert = this.Alert.bind(this);
    this.Alerts = this.Alerts.bind(this);
  }

  componentDidMount() {
    if (!localStorage.getItem("token")) {
      window.location.href = "/rubrongkpru";
    }
    axios
      .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/Showstudent/" + localStorage.getItem("id"))
      .then((response) => {
        if (response.data.length !== 0) {
          this.setState({
            OLDID: response.data[0]["OLDID"],
            FULLNAME: response.data[0]["PNAME"] + response.data[0]["NAME"],
            Type_name: response.data[0]["Type_name"],
            level_name_long: response.data[0]["level_name_long"],
            nameeng: response.data[0]["E_NAME"],
          });
          if (
            response.data[0]["LEVEL1"] === "1" &&
            (response.data[0]["mjcode"] === "28" ||
              response.data[0]["mjcode"] === "48" ||
              response.data[0]["mjcode"] === "77")
          ) {
            this.setState({ t_mjname: "การศึกษา (" + response.data[0]["t_mjname"] + ")" });
          } else if (
            response.data[0]["LEVEL1"] === "y" &&
            (response.data[0]["mjcode"] === "d9" ||
              response.data[0]["mjcode"] === "h4" ||
              response.data[0]["mjcode"] === "h5" ||
              response.data[0]["mjcode"] === "h6" ||
              response.data[0]["mjcode"] === "h7")
          ) {
            this.setState({ t_mjname: "บริหารธุรกิจ (" + response.data[0]["t_mjname"] + ")" });
          } else if (
            response.data[0]["LEVEL1"] === "4" &&
            (response.data[0]["mjcode"] === "19" ||
              response.data[0]["mjcode"] === "59" ||
              response.data[0]["mjcode"] === "h3")
          ) {
            this.setState({ t_mjname: "วิทยาศาสตร์ (" + response.data[0]["t_mjname"] + ")" });
          } else if (response.data[0]["LEVEL1"] === "4" && response.data[0]["mjcode"] === "f3") {
            this.setState({ t_mjname: "เทคโนโลยีภูมิศาสตร์ (" + response.data[0]["t_mjname"] + ")" });
          } else {
            this.setState({ t_mjname: response.data[0]["t_mjname"] });
          }
          if (
            response.data[0]["STATUS"] === "7" ||
            response.data[0]["STATUS"] === "a" ||
            response.data[0]["STATUS"] === "b" ||
            response.data[0]["STATUS"] === "c" ||
            response.data[0]["STATUS"] === "d"
          ) {
            axios
              .get("https://mua.kpru.ac.th/FrontEnd_Tabian/petition/CheckImage/" + localStorage.getItem("id"))
              .then((CheckImage) => {
                if (CheckImage.data.length !== 0) {
                  this.setState({ CheckImage: !CheckImage.data[0]["CheckImage"] });
                }
              });
          }
        }
      });
    axios
      .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/ShowTypePetition/" + localStorage.getItem("id"))
      .then((TypePetition) => {
        if (TypePetition.data.length !== 0) {
          this.setState({ array_TypePetition: TypePetition.data });
        }
      });
    axios
      .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/DetailPetition/" + localStorage.getItem("id"))
      .then((DetailPetition) => {
        if (DetailPetition.data.length !== 0) {
          DetailPetition.data[DetailPetition.data.length] = { DETAILPITITION_ID: "0", DETAILPITITION_NAME: "อื่นๆ" };
          this.setState({ array_DetailPetition: DetailPetition.data });
        }
      });
    axios.get(ConfigData.SERVER_URL + "FrontEnd_Tabian/student/showcertificatecourse/").then((Certificatecoure) => {
      if (Certificatecoure.data.length !== 0) {
        this.setState({ array_Certificatecoure: Certificatecoure.data });
      }
    });
  }

  handleTypePetitionChange(event) {
    var spitvalue = event.target.value.split(",");
    this.setState({ [event.target.name]: spitvalue[0] });
    this.setState({ TypesRubrongName: spitvalue[1] });
    this.setState({ TypesRubrongMoney: spitvalue[2] });
    if (["26", "27", "28", "29"].includes(String(spitvalue[0]))) {
      Swal.fire({
        icon: "info",
        title: "กรุณานำส่งรูปถ่าย",
        text: "กรุณานำส่งรูปถ่าย ณ ห้องงานทะเบียนและประมวลผล สำนักส่งเสริมวิชาการและงานทะเบียน",
        confirmButtonText: "รับทราบ",
        confirmButtonColor: "#43a047",
      });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleNewsChange(event) {
    this.setState({ [event.target.name]: event.target.checked });
    if (event.target.checked) {
      if (event.target.name === "RubrongTH") {
        this.setState({ box1: "1" });
      } else if (event.target.name === "RubrongEN") {
        this.setState({ box2: "1" });
      }
    } else {
      if (event.target.name === "RubrongTH") {
        this.setState({ box1: 0 });
      } else if (event.target.name === "RubrongEN") {
        this.setState({ box2: 0 });
      }
    }
  }

  handlePetitionChange(value) {
    if (!value) {
      this.setState({ petition: 0, box3: null, petitionValue: undefined });
      return;
    }
    const separator = String(value).indexOf(",");
    const petitionId = separator === -1 ? String(value) : String(value).slice(0, separator);
    const petitionName = separator === -1 ? "" : String(value).slice(separator + 1);
    if (petitionId !== "0") {
      this.setState({ petition: petitionId, box3: petitionName, petitionValue: value });
    } else {
      this.setState({ petition: petitionId, box3: null, petitionValue: value });
    }
  }

  handleCheck(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  handlemyFileChange(event) {
    this.getBase64(event.target.files[0], (files) => {
      this.setState({ [event.target.name]: files });
      this.setState({ [event.target.name + "_name"]: event.target.files[0].name });
    });
  }

  getBase64(files, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(files);
  }

  handleReset(event) {
    this.setState({
      checked: false,
      SelecteTypesRubrong: null,
      TypesRubrongName: null,
      TypesRubrongMoney: null,
      nameeng: null,
      numhome: null,
      moo: null,
      Road: null,
      SOI: null,
      Province: null,
      District: null,
      Subdistrict: null,
      PostalCode: null,
      number: null,
      RubrongTH: "2",
      RubrongEN: "2",
      myFile: null,
      noticeFile: null,
      box1: 0,
      box2: 0,
      totalRubrong: 0,
      totalMoney: 0,
      box3: null,
      petition: null,
      petitionValue: undefined,
      certificatecoure: null,
      openratting: false,
    });
  }

  modalSubmit_open(event) {
    event.preventDefault();
    var total = parseInt(this.state.box1) + parseInt(this.state.box2);
    this.setState({ totalRubrong: total });
    total = total * parseInt(this.state.TypesRubrongMoney);
    this.setState({ totalMoney: total });
    this.setState({ modalshowconfirm: true });
  }

  modalSubmit_close(event) {
    event.preventDefault();
    this.setState({ modalshowconfirm: false });
    this.setState({ totalRubrong: 0 });
    this.setState({ totalMoney: 0 });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ checkconfirm: false });
    let bodydata = {
      SelecteTypesRubrong: this.state.SelecteTypesRubrong,
      TypesRubrongName: this.state.TypesRubrongName,
      nameeng: this.state.nameeng,
      numhome: this.state.numhome,
      moo: this.state.moo,
      Road: this.state.Road,
      SOI: this.state.SOI,
      Province: this.state.Province,
      District: this.state.District,
      Subdistrict: this.state.Subdistrict,
      PostalCode: this.state.PostalCode,
      number: this.state.number,
      RubrongTH: this.state.box1,
      RubrongEN: this.state.box2,
      petition: this.state.box3,
      box3: this.state.petition,
      myFile: this.state.myFile,
      noticeFile: this.state.noticeFile,
      certificatecoure: this.state.certificatecoure,
    };
    axios
      .get("https://mua.kpru.ac.th/FrontEnd_Rating/rating/check/" + localStorage.getItem("id") + "/10")
      .then((res) => {
        const data = res.data;
        if (data.success === 0) {
            this.setState({ modalshowconfirm: false });
          this.setState({ openratting: true });
        } else {
          axios
            .post(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/InsertPetition/" + this.state.OLDID, bodydata)
            .then((data) => {
              if (data.data === 1) {
                this.Alert();
              }
            });
        }
      });
  }
  Alert() {
    Swal.fire({
      icon: "success",
      title: "เพิ่มคำร้องเสร็จสิ้น",
      timer: 1200,
      timerProgressBar: true,
      showConfirmButton: false,
    }).then((res) => {
      this.setState({ openratting: false });
      window.location.href = "datarubrong";
    });
  }
  Alerts() {
    axios.post("https://mua.kpru.ac.th/FrontEnd_Rating/rating/check",{
        feedback: this.state.feedback,
        feedback1: this.state.feedback1,
        feedback2: this.state.feedback2,
        system_kpru: "10",
        id_no: localStorage.getItem("id")
    }).then((res)=>{
        Swal.fire({
            icon: "success",
            title: "ขอบคุณสำหรับการประเมิน",
            timer: 1200,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then((res) => {
            let bodydata = {
              SelecteTypesRubrong: this.state.SelecteTypesRubrong,
              TypesRubrongName: this.state.TypesRubrongName,
              nameeng: this.state.nameeng,
              numhome: this.state.numhome,
              moo: this.state.moo,
              Road: this.state.Road,
              SOI: this.state.SOI,
              Province: this.state.Province,
              District: this.state.District,
              Subdistrict: this.state.Subdistrict,
              PostalCode: this.state.PostalCode,
              number: this.state.number,
              RubrongTH: this.state.box1,
              RubrongEN: this.state.box2,
              petition: this.state.box3,
              box3: this.state.petition,
              myFile: this.state.myFile,
              noticeFile: this.state.noticeFile,
              certificatecoure: this.state.certificatecoure,
            };
            axios
              .post(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/InsertPetition/" + this.state.OLDID, bodydata)
              .then((data) => {
                if (data.data === 1) {
                  this.setState({ openratting: false });
                  Swal.fire({
                    icon: "success",
                    title: "เพิ่มคำร้องเสร็จสิ้น",
                    timer: 1200,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href = "datarubrong";
                  });
                }
              });
          });
    })
   
  }
  render() {
    const canSubmit =
      (this.state.RubrongTH || this.state.RubrongEN) &&
      this.state.SelecteTypesRubrong !== null &&
      this.state.nameeng !== null &&
      this.state.number !== null &&
      this.state.box3 !== null &&
      this.state.checked &&
      !(this.state.SelecteTypesRubrong === "30" && this.state.certificatecoure === null);

    return (
      <>
        <RatingModal
          isOpen={this.state.openratting}
          values={{
            feedback: this.state.feedback,
            feedback1: this.state.feedback1,
            feedback2: this.state.feedback2,
          }}
          onChange={(field, score) => this.setState({ [field]: score })}
          onSubmit={() => this.Alerts()}
        />
        <form className="petition-page" onSubmit={this.modalSubmit_open}>
          <div className="petition-hero">
            <h1>ยื่นคำร้องขอเอกสารทางการศึกษา</h1>
            <p>กรอกข้อมูลให้ครบถ้วนตามลำดับ แล้วกดบันทึกด้านล่างของฟอร์ม</p>
          </div>

          <section className="petition-card">
            <div className="petition-card-head">
              <span>1</span> ประเภทเอกสาร
            </div>
            <div className="petition-card-body">
              <div className="petition-field">
                <label htmlFor="SelecteTypesRubrong">
                  ประเภทเอกสารทางการศึกษา <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  id="SelecteTypesRubrong"
                  name="SelecteTypesRubrong"
                  onChange={this.handleTypePetitionChange}
                  required
                >
                  <option value="" hidden>
                    ระบุประเภทเอกสารทางการศึกษา
                  </option>
                  {this.state.array_TypePetition.map((data) => (
                    <option
                      key={data.TYPEPITITION_ID}
                      value={data.TYPEPITITION_ID + "," + data.TYPEPITITION_NAME + "," + data.TYPEPITITION_MONEY}
                    >
                      {data.TYPEPITITION_NAME}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </section>

          <section className="petition-card">
            <div className="petition-card-head">
              <span>2</span> ข้อมูลนักศึกษา
            </div>
            <div className="petition-card-body">
              <div className="petition-info-grid">
                <div className="petition-info-item">
                  <span>รหัสนักศึกษา</span>
                  <strong>{this.state.OLDID || "-"}</strong>
                </div>
                <div className="petition-info-item">
                  <span>ชื่อ-นามสกุล</span>
                  <strong>{this.state.FULLNAME || "-"}</strong>
                </div>
                <div className="petition-info-item">
                  <span>ประเภทนักศึกษา</span>
                  <strong>{this.state.Type_name || "-"}</strong>
                </div>
                <div className="petition-info-item">
                  <span>หลักสูตร</span>
                  <strong>{this.state.level_name_long || "-"}</strong>
                </div>
                <div className="petition-info-item" style={{ gridColumn: "1 / -1" }}>
                  <span>สาขาวิชา/วิชาเอก</span>
                  <strong>{this.state.t_mjname || "-"}</strong>
                </div>
              </div>
            </div>
          </section>

          <section className="petition-card">
            <div className="petition-card-head">
              <span>3</span> ข้อมูลคำร้อง
            </div>
            <div className="petition-card-body">
              <div className="petition-grid">
                <div className="petition-field">
                  <label htmlFor="nameeng">
                    ชื่อ-นามสกุลภาษาอังกฤษ <span className="text-danger">*(ตัวพิมพ์ใหญ่เท่านั้น)</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nameeng"
                    name="nameeng"
                    value={this.state.nameeng}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="petition-field">
                  <label htmlFor="number">
                    เบอร์โทรศัพท์ที่ติดต่อได้ <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="number"
                    name="number"
                    value={this.state.number}
                    onChange={this.handleChange}
                    maxLength="10"
                    required
                  />
                </div>

                {this.state.SelecteTypesRubrong === "30" ? (
                  <div className="petition-field full" hidden={this.state.array_Certificatecoure.length === 0}>
                    <label htmlFor="certificatecoure">
                      รายวิชาที่ต้องการรับรอง <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      id="certificatecoure"
                      name="certificatecoure"
                      onChange={this.handleChange}
                      required
                    >
                      <option value="" hidden>
                        ระบุรายวิชาที่ต้องการรับรอง
                      </option>
                      {this.state.array_Certificatecoure.map((data) => (
                        <option key={data.TYPE_ID} value={data.TYPE_ID}>
                          {data.TYPE_NAME}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}

                <div className="petition-field full">
                  <label>มีความประสงค์ขอรับใบรับรองเป็น</label>
                  <div className="petition-choices">
                    <label className={`petition-choice${this.state.RubrongTH ? " active" : ""}`}>
                      <input
                        type="checkbox"
                        id="RubrongTH"
                        name="RubrongTH"
                        checked={this.state.RubrongTH}
                        onChange={this.handleNewsChange}
                      />
                      ใบรับรองภาษาไทย
                    </label>
                    {this.state.SelecteTypesRubrong === "1" ||
                    this.state.SelecteTypesRubrong === "2" ||
                    this.state.SelecteTypesRubrong === "3" ? (
                      <label className={`petition-choice${this.state.RubrongEN ? " active" : ""}`}>
                        <input
                          type="checkbox"
                          id="RubrongEN"
                          name="RubrongEN"
                          checked={this.state.RubrongEN}
                          onChange={this.handleNewsChange}
                        />
                        ใบรับรองภาษาอังกฤษ
                      </label>
                    ) : null}
                  </div>
                </div>

                {this.state.RubrongTH ? (
                  <div className="petition-field">
                    <label htmlFor="box1">จำนวนใบรับรองภาษาไทย (ฉบับ)</label>
                    <input
                      type="number"
                      className="form-control"
                      id="box1"
                      name="box1"
                      value={this.state.box1}
                      onChange={this.handleChange}
                      disabled
                    />
                  </div>
                ) : null}

                {this.state.RubrongEN ? (
                  <div className="petition-field">
                    <label htmlFor="box2">จำนวนใบรับรองภาษาอังกฤษ (ฉบับ)</label>
                    <input
                      type="number"
                      className="form-control"
                      id="box2"
                      name="box2"
                      value={this.state.box2}
                      onChange={this.handleChange}
                      disabled
                    />
                  </div>
                ) : null}

                {this.state.array_DetailPetition.length !== 0 ? (
                  <div className="petition-field full">
                    <label htmlFor="petition">
                      คำร้องและเหตุผลประกอบ <span className="text-danger">*</span>
                    </label>
                    <Select
                      showSearch
                      allowClear
                      size="large"
                      className="petition-select"
                      id="petition"
                      placeholder="พิมพ์เพื่อค้นหาคำร้องและเหตุผลประกอบ"
                      optionFilterProp="label"
                      value={this.state.petitionValue}
                      onChange={this.handlePetitionChange}
                      notFoundContent="ไม่พบรายการที่ค้นหา"
                      popupClassName="petition-select-dropdown"
                      listHeight={320}
                      filterOption={(input, option) =>
                        (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                      }
                      options={this.state.array_DetailPetition.map((data) => ({
                        value: data.DETAILPITITION_ID + "," + data.DETAILPITITION_NAME,
                        label: data.DETAILPITITION_NAME,
                      }))}
                    />
                  </div>
                ) : null}

                {this.state.petition === "0" || this.state.array_DetailPetition.length === 0 ? (
                  <div className="petition-field full">
                    <label htmlFor="box3">โปรดระบุเหตุผลประกอบ</label>
                    <input
                      type="text"
                      className="form-control"
                      id="box3"
                      name="box3"
                      value={this.state.box3}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                ) : null}

                {this.state.CheckImage ? (
                  <div className="petition-field full">
                    <div className="petition-file">
                      <label htmlFor="myFile">รูปถ่ายชุดครุย ตามหลักสูตรที่ศึกษา</label>
                      <br />
                      <label htmlFor="myFile" className="custom-file-upload">
                        <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="myFile"
                        name="myFile"
                        accept="image/jpeg"
                        onChange={this.handlemyFileChange}
                        required
                      />
                      <span className="petition-file-name">{this.state.myFile_name}</span>
                      <div className="text-danger">ไฟล์ที่สามารถอัปโหลดได้ *.jpg เท่านั้น</div>
                    </div>
                  </div>
                ) : null}

                {this.state.SelecteTypesRubrong === "5" ||
                this.state.SelecteTypesRubrong === "19" ||
                this.state.SelecteTypesRubrong === "21" ||
                this.state.SelecteTypesRubrong === "34" ||
                this.state.SelecteTypesRubrong === "35" ||
                this.state.SelecteTypesRubrong === "36" ? (
                  <div className="petition-field full">
                    <div className="petition-file">
                      <label htmlFor="noticeFile">ใบแจ้งความ</label>
                      <br />
                      <label htmlFor="noticeFile" className="custom-file-upload">
                        <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="noticeFile"
                        name="noticeFile"
                        accept=".pdf"
                        onChange={this.handlemyFileChange}
                        required
                      />
                      <span className="petition-file-name">{this.state.noticeFile_name}</span>
                      <div className="text-danger">ไฟล์ที่สามารถอัปโหลดได้ *.pdf เท่านั้น</div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </section>

          <section className="petition-actions">
            <label className="petition-certify" htmlFor="vehicle1">
              <input type="checkbox" id="vehicle1" name="checked" checked={this.state.checked} onChange={this.handleCheck} />
              <span>ข้าพเจ้าขอรับรองว่า ข้อมูลข้างต้นเป็นความจริงทุกประการ</span>
            </label>
            <div className="petition-buttons">
              <button type="submit" className="btn btn-primary btn-md" disabled={!canSubmit}>
                บันทึก
              </button>
              <button type="reset" className="btn btn-danger btn-md" onClick={this.handleReset}>
                ยกเลิก
              </button>
            </div>
          </section>

          <MDBModal
            className="petition-confirm-modal"
            size="md"
            isOpen={this.state.modalshowconfirm}
            toggle={this.modalSubmit_close}
            centered
          >
            <MDBModalHeader toggle={this.modalSubmit_close}>
              ยืนยันการยื่นคำร้อง
            </MDBModalHeader>
            <MDBModalBody>
              <p className="petition-confirm-lead">กรุณาตรวจสอบรายละเอียดก่อนยืนยันการขอเอกสาร</p>
              <div className="petition-confirm-summary">
                <div className="petition-confirm-row">
                  <span>ประเภทเอกสาร</span>
                  <strong>{this.state.TypesRubrongName || "-"}</strong>
                </div>
                {this.state.RubrongTH ? (
                  <div className="petition-confirm-row">
                    <span>ใบรับรองภาษาไทย</span>
                    <strong>{this.state.box1} ฉบับ</strong>
                  </div>
                ) : null}
                {this.state.RubrongEN ? (
                  <div className="petition-confirm-row">
                    <span>ใบรับรองภาษาอังกฤษ</span>
                    <strong>{this.state.box2} ฉบับ</strong>
                  </div>
                ) : null}
                <div className="petition-confirm-row">
                  <span>จำนวนรวม</span>
                  <strong>{this.state.totalRubrong} ฉบับ</strong>
                </div>
                <div className="petition-confirm-row">
                  <span>ราคาต่อฉบับ</span>
                  <strong>{this.state.TypesRubrongMoney} บาท</strong>
                </div>
                <div className="petition-confirm-row total">
                  <span>ยอดชำระรวม</span>
                  <strong>{this.state.totalMoney} บาท</strong>
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <button type="button" className="btn petition-confirm-cancel" onClick={this.modalSubmit_close}>
                ปิด
              </button>
              <button
                type="button"
                className="btn petition-confirm-ok"
                onClick={this.handleSubmit}
                disabled={!this.state.checkconfirm}
              >
                <div id="demo" className="spinner-border spinner-border-sm" hidden={this.state.checkconfirm}></div>
                ยืนยัน
              </button>
            </MDBModalFooter>
          </MDBModal>
        </form>
      </>
    );
  }
}
